module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOBAMAAADDIxFwAAAAAXNSR0IB2cksfwAAABVQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgEApAAAAAd0Uk5TANDPEL//wLpEWA0AAABNSURBVHicRcnBDYAwDENRS5kAEAtAuUOZBCTYf5QmBLu+fT+MOzgrmFdVfXHcRNsmmLBe/hODIPyImET8KZGUKAo8RYFLJ8enk+OQ1ABmAQsgxMFCewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/select-sort-arrow@2x.png
// module id = 908
// module chunks = 0